import { useEffect, useRef } from 'react'
import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost'
const REFRESH_BUFFER_MS = 2 * 60 * 1000 // 2 minutos antes da expiração
const CHECK_INTERVAL_MS = 60 * 1000 // verificar a cada 1 minuto

function parseExpFromToken(token: string): number | null {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    const payload = JSON.parse(jsonPayload)
    return payload.exp ? payload.exp * 1000 : null
  } catch {
    return null
  }
}

export function useTokenRefresh() {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => {
    const refreshIfNeeded = async () => {
      const token = localStorage.getItem('token')
      const refreshToken = localStorage.getItem('refreshToken')
      if (!token || !refreshToken) return

      const exp = parseExpFromToken(token)
      if (!exp) return

      const now = Date.now()
      const timeUntilExp = exp - now

      if (timeUntilExp < REFRESH_BUFFER_MS) {
        console.log('[TokenRefresh] Token expira em', Math.round(timeUntilExp / 1000), 's, renovando proativamente...')
        try {
          const res = await axios.post(`${API_URL}/api/v1/auth/refresh`, {
            refresh_token: refreshToken,
          })
          const { access_token, refresh_token } = res.data
          localStorage.setItem('token', access_token)
          if (refresh_token) {
            localStorage.setItem('refreshToken', refresh_token)
          }
          console.log('[TokenRefresh] Token renovado com sucesso')
        } catch (err: any) {
          console.error('[TokenRefresh] Falha na renovação proativa:', err.response?.status, err.response?.data)
          // Não limpar auth aqui — deixar o interceptor de 401 lidar se necessário
        }
      }
    }

    // Verificar imediatamente no mount
    refreshIfNeeded()

    intervalRef.current = setInterval(refreshIfNeeded, CHECK_INTERVAL_MS)
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [])
}
